import { render } from "./PipelineBoardDashboard.vue?vue&type=template&id=6afafe90&scoped=true"
import script from "./PipelineBoardDashboard.vue?vue&type=script&lang=js"
export * from "./PipelineBoardDashboard.vue?vue&type=script&lang=js"

import "./PipelineBoardDashboard.vue?vue&type=style&index=0&id=6afafe90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afafe90"]])

export default __exports__